<ng-container [ngSwitch]="status">
  <svg
    *ngSwitchCase="'ready'"
    class="status-icon tick"
    [class.tick--enter]="readyOrder !== null"
    [class.tick--still]="!pulse"
    [style.--tick-delay]="tickDelay"
    viewBox="0 0 16 16"
    aria-hidden="true"
  >
    <circle cx="8" cy="8" r="8" fill="#4F9F52" />
    <path
      d="M4.6 8.2l2.3 2.3 4.5-4.6"
      fill="none"
      stroke="#fff"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <span
    *ngSwitchCase="'waiting'"
    class="status-icon spinner"
    aria-hidden="true"
  ></span>
  <svg
    *ngSwitchCase="'unavailable'"
    class="status-icon"
    viewBox="0 0 16 16"
    aria-hidden="true"
  >
    <circle cx="8" cy="8" r="8" fill="#8A8A8A" />
    <path
      d="M5.5 5.5l5 5M10.5 5.5l-5 5"
      stroke="#fff"
      stroke-width="1.6"
      stroke-linecap="round"
    />
  </svg>
</ng-container>
